
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g38_45n1qQzrloopeX7_3UPzkmP_455p1_5Zx_45UxD58GoTs4Meta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexqj5v2KL9WtoqIk0LbVzU5iEzFQEOKNiGrh1U9iweZXwMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchJSxdtGMODGvUpSmTh0dY7uUOAL24exu7dcb3PowUljoMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexxDGIfbjatxKDyn3ipPEgyoaIesBRGr42kvpXBXhG1CYMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93tdIa_cavCVRS2vHe7a3Cst9Zsc9VKCGud4Dtj_45pAPkwMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexmWHKH7TTKxoC_A5BLnHQaJw6qh84oYNE9_VxPoIYaR4Meta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_9361r9KXGZUCu69b2e_454Si8B7pxbZuRz8qDGK4WmOwHMEMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexiSJ2JCqHrh2lP6VQpn_JYYgcT9Z79QBuwL_45leYC8IzYMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93dNSUWfHU87j0yUyTg9fZT4dpRCTny_oPI5pvwFc__voMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexiIm052xoJwfr7WuLrmHSk3S_dPh68TeFsM2d8ZqXbGAMeta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexO_7jc0cWE0hdcJpFZJ9LgWRtrnaZmHbWGkNpKUg6KC8Meta } from "/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexmWHKH7TTKxoC_A5BLnHQaJw6qh84oYNE9_VxPoIYaR4Meta || {},
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexiSJ2JCqHrh2lP6VQpn_JYYgcT9Z79QBuwL_45leYC8IzYMeta || {},
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexiIm052xoJwfr7WuLrmHSk3S_dPh68TeFsM2d8ZqXbGAMeta || {},
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexO_7jc0cWE0hdcJpFZJ9LgWRtrnaZmHbWGkNpKUg6KC8Meta || {},
    component: () => import("/codebuild/output/src1532022226/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]